import {StyleDeclarationValue, css} from 'aphrodite';
import {File} from './models';

export default function Picture({
    image,
    thumb,
    styles,
    width,
    height,
}: {
    image: File;
    thumb?: boolean;
    styles?: {
        root?: StyleDeclarationValue;
        picture?: StyleDeclarationValue;
    };
    width?: number | string;
    height?: number | string;
}) {
    const sources = Object.values(
        image[thumb && Object.values(image.thumbnails).length > 0 ? 'thumbnails' : 'sources']
    );
    // sort by type in reverse order because for some reason Chrome prefered jpg instead of webp
    // in case of jpeg is higher in sources than webp
    sources.sort((a, b) => (a.type > b.type ? -1 : 1));

    return (
        <picture className={css(styles?.picture)}>
            {sources.map(src => {
                return (
                    <source
                        key={src.url}
                        srcSet={src.url}
                        type={`image/${src.type}`}
                    />
                );
            })}
            <img
                className={css(styles?.root)}
                src={sources[0].url}
                alt={image.title}
                width={width || '100%'}
                height={height}
            />
        </picture>
    );
}
